import React from "react";
import { useNavigate } from "react-router-dom";
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Typography,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import EventAvailableIcon from "@mui/icons-material/EventAvailable"; // Bookings
import StarRateIcon from "@mui/icons-material/StarRate"; // Ratings
import SupportAgentIcon from "@mui/icons-material/SupportAgent"; // Support

const Footer = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  const handleNavigation = (event, newValue) => {
    setValue(newValue);
    const routes = ["/", "/my-bookings", "/reviews", "/contact"];
    navigate(routes[newValue]);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#90caf9",
        boxShadow: 3,
        zIndex: 1300, // ensure footer stays above page content (including home page sections)
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={handleNavigation}
        sx={{ backgroundColor: "#bbdefb", borderRadius: 2, padding: 1 }}
      >
        <BottomNavigationAction label="Home" icon={<HomeIcon />} />
        <BottomNavigationAction
          label="Bookings"
          icon={<EventAvailableIcon />}
        />
        <BottomNavigationAction label="Rating" icon={<StarRateIcon />} />
        <BottomNavigationAction label="Support" icon={<SupportAgentIcon />} />
      </BottomNavigation>
      <Typography
        variant="body2"
        align="center"
        sx={{ padding: 1, backgroundColor: "#64b5f6", color: "white" }}
      >
        &copy; {new Date().getFullYear()}{" "}
        <a
          href="https://www.tricles.com"
          style={{ color: "white", textDecoration: "none" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Tricles.com
        </a>
        . All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
